import {
  createRouter,
  createWebHistory
} from 'vue-router'

import SignIn from '../pages/SignIn.vue'
import Home from '../pages/Home.vue'
import Dashboard from '../pages/Dashboard.vue'
import GoogleCallback from '../pages/GoogleCallback.vue'
// import PublicPoll from '../pages/PublicPoll.vue'
import MyInfluencers from '../pages/MyInfluencers.vue'
import MySpent from '../pages/MySpent.vue'
//  Campaigns
import CampaignsList from '../pages/Campaigns/CampaignsList.vue';
import CampaignCreation from '../pages/Campaigns/CampaignCreation.vue';
import CampaignDetails from '../pages/Campaigns/CampaignDetails.vue';
//  Inventory
import InventoryList from '../pages/Inventory/InventoryList.vue';
import InventoryDetails from '../pages/Inventory/InventoryDetails.vue';

import {
  AuthAPIInstance
} from '../api'

import ChannelList from '../pages/Admin/Channels/ChannelList.vue'
import AdTypeList from '../pages/Admin/AdTypes/AdTypeList.vue';
import AdPlacementTypeList from '../pages/Admin/AdPlacementTypes/AdPlacementTypeList.vue'
import AdParameterList from '../pages/Admin/AdParameters/AdParameterList.vue';
import {
  AuthHelper
} from '../helpers/auth.helper'



const routes = [{
    path: '/sign-in',
    name: 'SignIn',
    component: SignIn,
  },
  {
    path: '/callback/google',
    name: 'GoogleCallback',
    component: GoogleCallback,
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      auth: true
    },
    children: [
      // Dashboard
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
          auth: true
        },
      },


      // Campaigns
      {
        path: '/campaigns',
        name: 'CampaignsList',
        component: CampaignsList,
        meta: {
          auth: true
        },
      },
      {
        path: '/campaigns/:id',
        name: 'CampaignDetails',
        component: CampaignDetails,
        meta: {
          auth: true
        },
      },
      {
        path: '/new-poll/:typeId',
        name: 'CampaignCreation',
        component: CampaignCreation,
        meta: {
          auth: true
        },
      },

      // Inventory
      {
        path: '/inventory',
        name: 'InventoryList',
        component: InventoryList,
        meta: {
          auth: true,
          roles: ['PUBLISHER']
        },
      },
      {
        path: '/inventory/:id',
        name: 'InventoryDetails',
        component: InventoryDetails,
        meta: {
          auth: true,
          roles: ['PUBLISHER']
        },
      },


      {
        path: '/campaigns/:id',
        name: 'CampaignDetails',
        component: CampaignDetails,
        meta: {
          auth: true,
          roles: ['PUBLISHER']
        },
      },
      {
        path: '/new-poll/:typeId',
        name: 'CampaignCreation',
        component: CampaignCreation,
        meta: {
          auth: true,
          roles: []
        },
      },





      // Influencers
      {
        path: '/my-influencers',
        name: 'MyInfluencers',
        component: MyInfluencers,
        meta: {
          auth: true
        },
      },

      // Spent

      {
        path: '/my-spent',
        name: 'MySpent',
        component: MySpent,
        meta: {
          auth: true
        },
      },


      // --------------------ADMIN ROUTES--------------------
      {
        path: '/admin/ad-channels',
        name: 'Channels',
        component: ChannelList,
        meta: {
          auth: true,
          roles: ['admin']
        },
      },

      {
        path: '/admin/ad-types',
        name: 'AdTypes',
        component: AdTypeList,
        meta: {
          auth: true,
          roles: ['admin']
        },
      },

      {
        path: '/admin/ad-placement-types',
        name: 'AdPlacementTypes',
        component: AdPlacementTypeList,
        meta: {
          auth: true,
          roles: ['admin']
        },
      },

      {
        path: '/admin/ad-parameters',
        name: 'AdParameters',
        component: AdParameterList,
        meta: {
          auth: true,
          roles: ['admin']
        },

      },

    ]
  },
  // {
  //   path: '/public/poll',
  //   name: 'PublicPoll',
  //   component: PublicPoll,
  // },

]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router
  .beforeEach(async (to, from, next) => {
    if (to.meta.auth) {
      const token = await AuthHelper.getToken()

      if (!token) return next({
        path: '/sign-in',
        replace: true
      });

      try {
        const {
          exp
        } = await AuthAPIInstance.validateToken(token);
        console.log("TOKEN VALID");

        AuthHelper.setRefresh(exp);

        return next();

      } catch (error) {
        console.log("ERROR", error);
        await AuthHelper.setToken()

        return next({
          path: '/sign-in',
          replace: true
        });
      }
    }

    return next();
  });

export default router